module.exports = __webpack_public_path__ + "media/images/icon__close--rb-gray@2x-a4982f4ddb94b0defe6cdb5833644672.png";